export const technology = {
  hero: {
    title: 'Black Tech from the Lab',
    subtitle: 'Cutting-Edge Food Extraction',
    description: 'ShanDouDou\'s core competitiveness stems from deep mastery and continuous innovation in frontier food science technologies. We integrate cold extraction, freeze-drying, and microencapsulation into every product\'s R&D process.',
  },
  labStats: [
    { label: 'R&D Staff', value: '42', unit: '' },
    { label: 'Patents', value: '18', unit: '' },
    { label: 'Formulas', value: '2000+', unit: '' },
    { label: 'Test Standards', value: '300+', unit: '' },
  ],
  technologies: [
    {
      shortName: 'Freeze Drying',
      name: 'FD Freeze-Drying Technology',
      stat: '-40°C',
      statDesc: 'Vacuum Freeze Temp',
      description: 'In a vacuum environment at -40°C, moisture in ingredients sublimates directly from solid to gas without passing through liquid. This technology maximally preserves color, aroma, flavor, and active nutrients, achieving a freshness lock rate of 98%+.',
      benefits: ['98%+ Nutrient Retention', 'Excellent Rehydration', 'No Preservatives Needed', '90% Weight Reduction'],
    },
    {
      shortName: 'Microencapsulation',
      name: 'Microencapsulation Targeting',
      stat: '< 100μm',
      statDesc: 'Capsule Size Control',
      description: 'Using natural wall materials to encapsulate active ingredients (ginsenosides, GABA, anthocyanins, etc.) in micron-sized capsules. Effectively solves the bitter taste and oxidation issues of traditional Chinese medicine, enabling intestinal targeted release and improved bioavailability.',
      benefits: ['Masks Unpleasant Flavors', 'Prevents Oxidation', 'Intestinal Targeted Release', '3x Absorption Rate'],
    },
    {
      shortName: 'Cold Extraction',
      name: 'Low-Temp Cold Extraction',
      stat: '< 60°C',
      statDesc: 'Full Low-Temp Control',
      description: 'Using ultra-low temperature solvent extraction technology to extract plant active ingredients below 60°C. Compared to traditional high-temperature boiling, cold extraction completely preserves heat-sensitive nutrients (vitamin C, active enzymes, polyphenols).',
      benefits: ['Zero Heat-Sensitive Loss', 'No High-Temp Carbonization', 'Solvent Recyclable', '>95% Extraction Purity'],
    },
    {
      shortName: 'Enzyme Engineering',
      name: 'Enzymatic Flavor Engineering',
      stat: '99%',
      statDesc: 'Bean Odor Removal Rate',
      description: 'Through precisely controlled enzymatic reactions, decompose odor precursor substances in soy, mushrooms, and other ingredients. While preserving protein and dietary fiber, completely remove bean and medicinal odors, leaving only the ingredient\'s natural aroma.',
      benefits: ['Complete Protein Preserved', 'Removes Bitter/Odd Tastes', 'Enhances Flavor Layers', 'Improved Digestibility'],
    },
  ],
  process: {
    title: 'Six-Step R&D Protocol',
    subtitle: 'From raw materials to finished products, every ShanDouDou product undergoes a rigorous six-step R&D process',
    steps: [
      { title: 'Raw Material Sourcing', desc: 'Direct sourcing from 36 premium global origins, DNA traceability testing for every batch' },
      { title: 'Component Analysis', desc: 'HPLC high-performance liquid chromatography to analyze active ingredient content' },
      { title: 'Process R&D', desc: 'Multi-variable orthogonal experiments to optimize the best process parameters' },
      { title: 'Sensory Evaluation', desc: '100-person sensory panel blind testing with data-driven taste scoring' },
      { title: 'Stability Testing', desc: 'Accelerated aging experiments to verify nutritional stability over shelf life' },
      { title: 'Production Release', desc: 'Full-batch third-party testing with clean label verification' },
    ],
  },
};